import { render, staticRenderFns } from "./TourGalleryGrid.vue?vue&type=template&id=2061d734&scoped=true&"
import script from "./TourGalleryGrid.vue?vue&type=script&lang=js&"
export * from "./TourGalleryGrid.vue?vue&type=script&lang=js&"
import style0 from "./TourGalleryGrid.vue?vue&type=style&index=0&id=2061d734&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2061d734",
  null
  
)

export default component.exports